import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardBody } from '../../components/CardBody';
import { CardHeader } from '../../components/CardHeader';

import { allProductsState } from '../../recoil/atoms';
import { ShopNowCardFooter } from '../HomeLander/HomeLanderMobile';
import { HeroCallout } from '../HeroCallout';
import { WistiaPanel } from '../../components/WistiaPanel';
import { NewsIcons } from '../../product_detail/components/NewsIcons';
import { ShopAllColors } from '../components/ShopAllColors';
import { ProductFeatures } from '../components/ProductFeatures';
import { LanderTopHero } from '../components/LanderTopHero';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { CardFooter } from '../../components/CardFooter';
import { useLanderControls } from '../LanderContext';
import { ProductReviewQuote } from '../components/ProductReviewQuote';

export const EverReadyPantLanderMobile: React.FC = () => {
  const allProducts = useRecoilValue(allProductsState);
  const { scrollToProductSection } = useLanderControls();

  const wistiaVideoId = 'txjj1yry1r';
  const padding = { padding: '145.0% 0 0 0' };

  return (
    <>
      <CardBody>
        <LanderTopHero
          heroImage={'mobile-everready-pant-lander-top-hero-1.jpg'}
          title={'EverReady Pant'}
          subTitle={'The most flattering pants you’ll ever put on.'}
        >
          <HeroCallout
            orderIndex={0}
            labelColor={'black'}
            label={'Flattering pockets'}
            inlineStyles={{
              mobile: {
                left: `59.5%`,
                top: `15%`,
                flexDirection: 'row-reverse',
              },
            }}
            titleStyles={{
              lineHeight: '18px',
              fontSize: '14px',
              marginRight: 0,
            }}
          />
          <HeroCallout
            orderIndex={1}
            labelColor={'black'}
            label={'Hidden shaping panels'}
            inlineStyles={{
              mobile: {
                left: `62%`,
                top: `28%`,
                flexDirection: 'row-reverse',
              },
            }}
            titleStyles={{
              lineHeight: '18px',
              fontSize: '14px',
              marginRight: 0,
            }}
          />
          <HeroCallout
            orderIndex={2}
            labelColor={'black'}
            label={'Smoothing fabric'}
            inlineStyles={{
              mobile: {
                right: `60%`,
                top: `45%`,
                flexDirection: 'row',
              },
            }}
            titleStyles={{
              lineHeight: '18px',
              fontSize: '14px',
            }}
          />
        </LanderTopHero>
      </CardBody>
      <ShopNowCardFooter onClick={scrollToProductSection} />
      <CardHeader />
      <CardBody>
        <NewsIcons />
        <ProductFeatures
          features={[
            {
              imgName: 'feature-everready-pant-desktop-1.jpg',
              title: 'Built-in Shaping',
              description: 'Interior shaping panels sculpt your tummy, hips and booty.',
            },
            {
              imgName: 'feature-everready-pant-desktop-2.jpg',
              title: 'Smoothing Fabric',
              description: 'Soft and compressive ponte with twill detail  conceals lumps and bumps.',
            },
            {
              imgName: 'feature-everready-pant-desktop-3.jpg',
              title: 'Wrinkle-Proof',
              description: 'No ironing needed - wash cold and hang dry for a polished look every time.',
            },
          ]}
        />
        <ProductReviewQuote
          backgroundColor="#efefef"
          quotes={[
            {
              quoteText: `"This is a magic tank top  - I haven’t looked this curvy in ages. I feel great every time I put this on."`,
              author: '- Leia B.',
            },
            {
              quoteText: `"This is a seriously intense tank, but it’s totally worth it and actually really comfortable when it’s on. "`,
              author: '- Saide R.',
            },
            {
              quoteText: `"I gave this a try because Honeylove has a good return policy - but you couldn’t wrestle this thing out of my greedy hands. One word - snatched."`,
              author: '- Jose T.',
            },
          ]}
          imgName="everready-pant-quote-1.jpg"
        />
        <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />
        <ShopAllColors product={allProducts[ProductHandle.EverReadyPant]} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default EverReadyPantLanderMobile;
